import { faStarHalf } from '@fortawesome/pro-duotone-svg-icons';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import {
  Image,
  EmptyState,
  EmptyStateContainer as EmptyStateContainerAtom,
  EmptyStateIcon,
} from 'components/atoms/empty-state';

const EmptyStateContainer = styled(EmptyStateContainerAtom)`
  ${Image} {
    background-color: var(--coolest-gray-20);
  }
  height: 100%;
`;

export const CSATEmptyState: FC = () => (
  <EmptyStateContainer>
    <EmptyState
      direction="horizontal"
      size="large"
      image={<EmptyStateIcon icon={faStarHalf} size="10x" />}
      title={<FormattedMessage id="csat.empty.title" />}
      message={<FormattedMessage id="csat.empty.message" />}
      // secondaryCTA={
      //   <EmptyState.CallToAction.Secondary>
      //     <FormattedMessage id="csat.empty.secondary" />
      //   </EmptyState.CallToAction.Secondary>
      // }
    />
  </EmptyStateContainer>
);
